export default "__VITE_ASSET__DbxMHIe5__"